<template>
  <div :class="`quiz-feedback d-flex align-items-center ${type}`">
    <i v-if="icon && type === 'success'" class="fa-solid fa-circle-check" />
    <i v-if="icon && type === 'danger'" class="fa-solid fa-circle-xmark" />
    {{ message }}
  </div>
</template>

<script setup>
// props
const props = defineProps({
  type: {
    type: String,
    required: true,
  },
  icon: {
    type: Boolean,
    default: true,
  },
  message: {
    type: String,
    required: true,
  },
});
</script>

<style scoped>
.fa-circle-check {
  color: #38b000b2;
}

.fa-circle-xmark {
  color: #d62828b2;
}

.quiz-feedback {
  gap: 12px;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 14px;
  user-select: none;
}
.quiz-feedback.success {
  background-color: #ebfee2;
  border: 1px solid #38b000b2;
  color: #38b000b2;
}

.quiz-feedback.danger {
  background-color: #fbe3e3;
  border: 1px solid #d62828b2;
  color: #d62828b2;
}
</style>
